import { FormattedMessage } from '@subaio/components'

import { asContainer } from 'lib/container'

import { IconHeaderError } from 'components/Icons'
import { SplashScreen } from 'components/Layout'

export const container = asContainer<{}>()({
	authentication: { type: 'public' },
	Running: () => (
		<SplashScreen
			title={<FormattedMessage id='notFound.title' defaultMessage='We could not find what you were looking for' />}
			icon={<IconHeaderError />}
		/>
	),
})
